import content from "app-content";

const getDiscountAriaLabel = ({ discount }) =>
  `${content.generic_accessibility_discount}: -${discount}%`;

export default getDiscountAriaLabel;
